
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Node": [
      "KainAppointment",
      "KainLinePatient",
      "KainLineUser",
      "KainLineVisitor",
      "KainMedicationFollowupMessage",
      "KainOutpatientQuestionnaire",
      "KainOutpatientQuestionnaireQuestion",
      "KainOutpatientQuestionnaireSettingQuestionnaire",
      "PublicAddress",
      "PublicMedicationFollowupQuestionnaireRevision",
      "PublicMedicationFollowupQuestionnaireSheet",
      "PublicOrganization",
      "PublicOrganizationAddress",
      "PublicSlot",
      "PublicWebBookingsSetting"
    ]
  }
};
      export default result;
    